import { ReactElement, ChangeEvent, InputHTMLAttributes } from "react"
import { addZero, clamp } from "../../../../shared/helpers";
import DatePickerService from "../../../../services/datepicker/datepicker-service";
import { CalendarDate } from "../../../../services/datepicker/interfaces/calendar-date";
import styles from "./TimeSelector.module.scss";

interface TimeSelectorProps
{
    currentDate: CalendarDate;
    selectedDate: CalendarDate;
    datepickerService: DatePickerService;
    updateDate: (date: CalendarDate) => void;
}

const TimeSelector = (props: TimeSelectorProps): ReactElement =>
{
    const inputs = ["hours", "minutes", "seconds"];
    const date = props.selectedDate ?? props.currentDate;

    function onChange(e: ChangeEvent): void
    {
        const target = e.target as HTMLInputElement;
        const max = target.name === "hours" ? 24 : 60;
        const value = clamp(0, max, parseInt(target.value));
        const updateDate = { ...date, [target.name]: value };
        props.updateDate(props.datepickerService.setCurrentDate(updateDate));
    }

    function sharedProps(name: string): InputHTMLAttributes<HTMLInputElement>
    {
        const max = name === "hours" ? 24 : 60;
        const value = addZero((date as any)[name]);
        return { type: "number", min: 0, max, name, value, onChange }
    }

    return (
        <div className={styles.timeSelector}>
            {inputs.map((x: string) => (
                <div key={x} className={styles.inputWrapper}>
                    <input {...sharedProps(x)} />
                </div>
            ))}
        </div>
    )
}

export default TimeSelector;